import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hideOnMobile", "sticky"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { mediaQueryDesktopMin, colorWhite } from 'styleUtils';
import { jsx as _jsx } from "react/jsx-runtime";
var Wrapper = /*#__PURE__*/styled(function (_ref) {
  var hideOnMobile = _ref.hideOnMobile,
      sticky = _ref.sticky,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("section", _objectSpread({}, props));
}).withConfig({
  componentId: "sc-ur00tc-0"
})(["background-color:", ";border-radius:2px;box-shadow:0 1px 2px rgba(0,0,0,0.06),0 1px 2px rgba(0,0,0,0.14);padding:16px;margin:0 0 16px 0;width:100%;@media ", "{padding:24px;}", " ", ""], colorWhite, mediaQueryDesktopMin, function (_ref2) {
  var hideOnMobile = _ref2.hideOnMobile;

  if (hideOnMobile) {
    return "\n        display: none;\n\n        @media ".concat(mediaQueryDesktopMin, " {\n          display: block;\n        }\n      ");
  }

  return '';
}, function (_ref3) {
  var sticky = _ref3.sticky;

  if (sticky) {
    return "\n        position: sticky;\n        top: 16px;\n      ";
  }

  return '';
});
export default Wrapper;